import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Tree, TreeNode } from 'react-organizational-chart';
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { BasicFetch } from "../../../utils/BasicFetch.ts";
import { Clutch } from '../../../types/Clutch';
import { ClutchItem } from '../Clutches.tsx';
import { CollectionReptile } from '../../collection/types/CollectionTypes.ts';
import { Morph } from '../../../types/Morph.ts';
import { useRepToolContext } from '../../../RepToolContext.tsx';

const PHOTO_NOT_AVAILABLE = "images/notavailable.jpg";

interface ViewClutchModalProps {
  clutch: Clutch;
  onClose: () => void;
}

const ParentNode = ({ mother, father }: { mother: CollectionReptile, father: CollectionReptile }) => {
  return (
    <div className='d-flex flex-row'>
      <div className='col-5 p-0'>
        <ReptileTreeNode
          reptile={father}
          extraClass='ml-auto my-auto h-100'
        />
      </div>
      <div className='col-2 p-0'>
        <div className='h-50 d-flex flex-row'>
          <div className='h-100 w-50 border-top-0 border-left-0 border-right-0' style={{ borderColor: '#2bc3c3', borderWidth: 3, borderStyle: 'solid' }}></div>
          <div className='border-right-0 h-100 w-50 border-top-0' style={{ borderColor: '#2bc3c3', borderWidth: 3, borderStyle: 'solid' }} ></div>
        </div>
        <div className='h-50 d-flex flex-row'>
          <div className='h-100 w-50 border-0'></div>
          <div className='border-right-0 border-bottom-0 border-top-0 h-100 w-50' style={{ borderColor: '#2bc3c3', borderWidth: 3, borderStyle: 'solid' }}></div>
        </div>
      </div>
      <div className='col-5 p-0 flex-fill'>
        <ReptileTreeNode
          reptile={mother}
          extraClass='mr-auto my-auto h-100'
        />
      </div>
    </div>
  )
}


const ReptileTreeNode = ({ reptile, extraClass, morphs }: { reptile: CollectionReptile, extraClass: string, morphs: Morph[] }) => {
  // determine if picture load failed
  let picture = { src: reptile.picture, credit: '' };
  if (reptile.picture === PHOTO_NOT_AVAILABLE || reptile.picture === '') {
    if (reptile.morph_name_id) {
      const foundMorphPicture = morphs.find((morph) => morph.morph_name_id === reptile.morph_name_id)?.pictures?.[0] || null;
      if (foundMorphPicture) {
        picture.src = foundMorphPicture.src;
        picture.credit = foundMorphPicture.credit;
      }
    }
  }

  return (
    <div className={`reptile-tile border border-${reptile.gender} p-2 box-shadow-${reptile.gender} ${extraClass}`} style={{ maxWidth: 100 }}>
      <div className='d-flex flex-column'>
        <span className='text-truncate'>{reptile.name || reptile.morph_name}</span>
      </div>
      <img className="w-100" src={picture.src || PHOTO_NOT_AVAILABLE} />
      {picture.credit && <h6 className="tile-photo-credit">{picture.credit}</h6>}
    </div>
  )
}

export const ViewClutchModal: React.FC<ViewClutchModalProps> = ({ clutch, onClose }) => {
  const { appendControls } = useRepToolContext();
  useEffect(() => {
    appendControls(null, "Clutch Family Tree");
  }, []);
  const reptileChildren = clutch.produced_reptiles;
  return (
    <ReptoolModal closeModal={onClose} title={'Clutch Family Tree'} body={
      <div className='overflow-scroll pb-4 h-100 w-100'>
        <Tree
          label=""
          lineWidth={'3px'}
          lineColor={'#2bc3c3'}
          lineBorderRadius={'10px'}
        >
          <TreeNode label={
            <ParentNode
              mother={clutch.mother}
              father={clutch.father}
            />
          } >
            {reptileChildren.map((child) => (
              <TreeNode label={
                <ReptileTreeNode
                  reptile={child}
                  extraClass='mx-auto'
                />
              } />
            ))}
          </TreeNode>
        </Tree>
      </div>
    }>

    </ReptoolModal>
  );
};
